/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Map_Not_SupportedInputs */

const en_ticket_map_not_supported = /** @type {(inputs: Ticket_Map_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geolocation is not supported by your browser`)
};

const ja_ticket_map_not_supported = /** @type {(inputs: Ticket_Map_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お使いのブラウザは位置情報に対応していません`)
};

const fr_ticket_map_not_supported = /** @type {(inputs: Ticket_Map_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La géolocalisation n'est pas prise en charge par votre navigateur`)
};

const de_ticket_map_not_supported = /** @type {(inputs: Ticket_Map_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geolokalisierung wird von Ihrem Browser nicht unterstützt`)
};

/**
* | output |
* | --- |
* | "Geolocation is not supported by your browser" |
*
* @param {Ticket_Map_Not_SupportedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_map_not_supported = /** @type {((inputs?: Ticket_Map_Not_SupportedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Map_Not_SupportedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_map_not_supported(inputs)
	if (locale === "ja") return ja_ticket_map_not_supported(inputs)
	if (locale === "fr") return fr_ticket_map_not_supported(inputs)
	return de_ticket_map_not_supported(inputs)
});